import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
  Checkbox,
  FormControlLabel,
} from "@mui/material";

export default function YesOrNoDialoge(props) {
  // const [checkState, setCheckState] = useState({
  //   show: false,
  //   name: undefined,
  // });
  return (
    <Dialog
      BackdropProps={{
        style: {
          // backgroundColor: "transparent",
        },
      }}
      PaperProps={{
        elevation: 1,
      }}
      fullWidth
      open={props.checkState.show}
      onClose={() => props.setCheckState({ ...props.checkState, show: false })}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle color="red" id="alert-dialog-title">
        توجه!
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {props.addOrder
            ? props.checkState.name
            : "آیا از " + props.checkState.name + " اطمینان دارید ؟"}
        </DialogContentText>
        {props.fillState && (
          <FormControlLabel
            control={
              <Checkbox
                checked={props.fillState.clear}
                onChange={(evt) => {
                  props.setFillState({
                    ...props.fillState,
                    clear: evt.target.checked,
                  });
                }}
              />
            }
            label="کاربران قبلی پاک شود"
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button
          sx={{ color: "#565656 !important" }}
          onClick={() => {
            props.callback();
            props.setCheckState({ ...props.checkState, show: false });
          }}
        >
          بله
        </Button>
        <Button
          color="secondary"
          onClick={() =>
            props.setCheckState({ ...props.checkState, show: false })
          }
        >
          خیر
        </Button>
      </DialogActions>
    </Dialog>
  );
}
